import React, { useCallback, useEffect, useState, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import uploadIcon from "../resources/images/upload-icon.png";
import MdlSelectSession from "../dialog/MdlSelectSession";

const ExamSchedule = () => {
  const { document_type } = useParams();

  const token = localStorage.getItem("token");
  const [loggedIn] = useState(!(token == null));
  const [Loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState("");
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);

  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mExamList, setMExamList] = useState([]);
  const [EXAM_ID, setEXAM_ID] = useState("");
  const [EXAM_NAME, setEXAM_NAME] = useState("");
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_STATUS, setSESSION_STATUS] = useState("");
  const [EXAM_SELECTED_POSITION, setEXAM_SELECTED_POSITION] = useState(0);
  // Default to a reasonable height so pages that don't postMessage still show
  const [iFrameHeight, setIFrameHeight] = useState("800px");
  // Refs to break circular dependencies
  const setFileUrLWithValuesRef = useRef(null);
  const iframeRef = useRef(null);
  const setSampleRef = useRef(null);


  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setIFrameHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Initialize session and document type
  useEffect(() => {
    window.scrollTo(0, 0);
    setDOCUMENT_TYPE(document_type);
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession[0]) {
      setSESSION_ID(mSession[0].session_id);
      setSESSION_NAME(mSession[0].session_name);
      setSESSION_STATUS(mSession[0].status);
    }
  }, [document_type]);

  // Fetch exam list when session is available
  const getExamList = useCallback(() => {
    if (!SESSION_ID) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getExamListLite.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const exams = response.data || [];
          setMExamList(exams);
          if (exams.length > 0) {
            const first = exams[EXAM_SELECTED_POSITION] || exams[0];
            setEXAM_ID(first.exam_id);
            setEXAM_NAME(first.exam_name);
          }
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching exam list:", error);
      });
  }, [SESSION_ID, EXAM_SELECTED_POSITION]);

  useEffect(() => {
    if (SESSION_ID) {
      getExamList();
    }
  }, [SESSION_ID, getExamList]);

  // Session dialog handlers
  const ChangeSession = useCallback(() => {
    setIsOpenSessionDialog(true);
  }, []);

  const HandleCloseSessionDialog = useCallback(() => {
    setIsOpenSessionDialog(false);
  }, []);

  const HandleSelectedSession = useCallback((session_id, session_name, session_status) => {
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setSESSION_STATUS(session_status);
    setIsOpenSessionDialog(false);
  }, []);

  // Exam selection handler
  const SelectExam = useCallback((exam_id, exam_name, position) => {
    setEXAM_ID(exam_id);
    setEXAM_NAME(exam_name);
    setEXAM_SELECTED_POSITION(position);
    // Generate URL when exam is selected (if sample is already loaded)
    if (SELECTED_SAMPLE_ID && FILE_NAME && SESSION_ID && setFileUrLWithValuesRef.current) {
      setFileUrLWithValuesRef.current(
        FILE_NAME,
        FILE_DIRECTORY,
        SELECTED_SAMPLE_ID,
        exam_id,
        exam_name
      );
    }
  }, [SELECTED_SAMPLE_ID, FILE_NAME, FILE_DIRECTORY, SESSION_ID]);


  // Internal function to build URL with all required parameters for exam_schedule.php
  const setFileUrLWithValues = useCallback((
    fileName,
    fileDirectory,
    sampleId,
    examId,
    examName
  ) => {
    if (!fileName || !sampleId || !examId || !SESSION_ID) {
      return;
    }
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    
    // Build URL for exam_schedule.php (no student_ids needed - gets all participating classes)
    // Prefer the fileDirectory coming from sample; if it's empty, fall back to TARGET_DIR
    let baseDir = "";
    if (fileDirectory && fileDirectory.length > 0) {
      baseDir = fileDirectory.endsWith("/") ? fileDirectory : fileDirectory + "/";
    } else if (process.env.REACT_APP_TARGET_DIR) {
      const td = process.env.REACT_APP_TARGET_DIR;
      baseDir = td.endsWith("/") ? td : td + "/";
    }

    let url =
      (process.env.REACT_APP_SERVER_NAME || "") +
      baseDir +
      fileName;
    url += "?session_id=" + encodeURIComponent(SESSION_ID || "");
    url += "&exam_id=" + encodeURIComponent(examId || "");
    url += "&exam_name=" + encodeURIComponent(examName || "");
    url += "&sample_id=" + encodeURIComponent(sampleId || "");
    url += "&system_code=" + encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "");
    url += "&school_code=" + encodeURIComponent(SCHOOL_CODE || "");
    
    if (process.env.NODE_ENV === 'development') {
      console.log("FILE_URL", url);
    }
    setFILE_URL(url);
  }, [SESSION_ID]);
  
  setFileUrLWithValuesRef.current = setFileUrLWithValues;

  // Set default sample and generate URL (first sample)
  const setSample = useCallback((samples) => {
    const list = (samples && samples.length > 0) ? samples : (mPrintableSamples && mPrintableSamples.length > 0 ? mPrintableSamples : null);
    if (!list || list.length === 0) {
      return;
    }
    
    const first = list[0];
    // Use the file_name from sample, or default to exam_schedule.php
    let fileName = first.file_name || '';
    if (!fileName || !fileName.includes('exam_schedule.php')) {
      fileName = 'AdmitCard/exam_schedule.php';
    }
    const sampleId = first.sample_id || '';
    const fileDirectory = first.file_directory || "";

    // Update state
    setFILE_NAME(fileName);
    setFILE_DIRECTORY(fileDirectory);
    setSELECTED_SAMPLE_POSITION(0);
    setSELECTED_SAMPLE_ID(sampleId);
    
    // Generate URL when exam is selected (no student selection needed)
    if (EXAM_ID && SESSION_ID && setFileUrLWithValuesRef.current) {
      setFileUrLWithValuesRef.current(
        fileName,
        fileDirectory,
        sampleId,
        EXAM_ID,
        EXAM_NAME
      );
    }
  }, [mPrintableSamples, EXAM_ID, EXAM_NAME, SESSION_ID]);
  
  setSampleRef.current = setSample;

  // Explicit sample selection handler (from UI)
  const SelectSample = useCallback(
    (sample, position) => {
      if (!sample) return;

      let fileName = sample.file_name || "";
      if (!fileName || !fileName.includes("exam_schedule.php")) {
        fileName = "AdmitCard/exam_schedule.php";
      }
      const sampleId = sample.sample_id || "";
      const fileDirectory = sample.file_directory || "";

      // Update state for selected sample
      setFILE_NAME(fileName);
      setFILE_DIRECTORY(fileDirectory);
      setSELECTED_SAMPLE_POSITION(position);
      setSELECTED_SAMPLE_ID(sampleId);

      // If exam already selected, regenerate URL
      if (EXAM_ID && SESSION_ID && setFileUrLWithValuesRef.current) {
        setFileUrLWithValuesRef.current(
          fileName,
          fileDirectory,
          sampleId,
          EXAM_ID,
          EXAM_NAME
        );
      }
    },
    [EXAM_ID, EXAM_NAME, SESSION_ID]
  );

  // Fetch printable samples
  const getPrintableSamples = useCallback(() => {
    if (!DOCUMENT_TYPE) {
      return;
    }
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: SCHOOL_CODE,
      document_type: DOCUMENT_TYPE,
    };

    if (process.env.NODE_ENV === 'development') {
      const queryString = new URLSearchParams(params).toString();
      console.log("getPrintableSample Full URL:", `${URL}${queryString}`);
    }

    axios
      .get(URL, {
        params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const samples = response.data || [];
          setMPrintableSamples(samples);
          if (setSampleRef.current) {
            setSampleRef.current(samples);
          }
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching printable samples:", error);
      });
  }, [DOCUMENT_TYPE]);

  // Fetch samples when document type is set
  useEffect(() => {
    if (DOCUMENT_TYPE) {
      getPrintableSamples();
    }
  }, [DOCUMENT_TYPE, getPrintableSamples]);

  // Generate URL when exam changes or when sample is loaded
  useEffect(() => {
    if (FILE_NAME && SELECTED_SAMPLE_ID && EXAM_ID && SESSION_ID && setFileUrLWithValuesRef.current) {
      setFileUrLWithValuesRef.current(
        FILE_NAME,
        FILE_DIRECTORY,
        SELECTED_SAMPLE_ID,
        EXAM_ID,
        EXAM_NAME
      );
    }
  }, [EXAM_ID, EXAM_NAME, SESSION_ID, FILE_NAME, FILE_DIRECTORY, SELECTED_SAMPLE_ID]);

  // Also generate URL when samples are loaded (in case exam was already selected)
  useEffect(() => {
    if (mPrintableSamples.length > 0 && !SELECTED_SAMPLE_ID && EXAM_ID && SESSION_ID) {
      if (setSampleRef.current) {
        setSampleRef.current(mPrintableSamples);
      }
    }
  }, [mPrintableSamples, EXAM_ID, SESSION_ID, SELECTED_SAMPLE_ID]);

  // Iframe handlers
  const handleIframeLoad = useCallback(() => {
    setShowPreview(false);
  }, []);

  const handleIframeError = useCallback(() => {
    setShowPreview(false);
  }, [FILE_URL]);

  // Show loading state when URL changes
  useEffect(() => {
    if (FILE_URL) {
      setShowPreview(true);
      const timeout = setTimeout(() => {
        setShowPreview(false);
      }, 2000);
      return () => clearTimeout(timeout);
    } else {
      setShowPreview(false);
    }
  }, [FILE_URL]);

  if (loggedIn === false) {
    return <Redirect to="/Login" />;
  }
  
  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#">Exam Schedule </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "30px", padding: "12px" }}
      >
        {/* Session Header */}
        <div
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
            borderRadius: "8px",
            padding: "10px 14px",
            marginBottom: "8px",
            boxShadow: "0 2px 8px rgba(102, 126, 234, 0.2)",
            cursor: "pointer",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onClick={ChangeSession}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(102, 126, 234, 0.2)";
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fa fa-calendar" style={{ fontSize: "16px", color: COLORS.white }} />
              <div>
                <div style={{ fontSize: "10px", color: "rgba(255, 255, 255, 0.9)", fontWeight: "500" }}>
                  Current Session
                </div>
                <div style={{ fontSize: "14px", color: COLORS.white, fontWeight: "600" }}>
                  {SESSION_NAME} ({SESSION_STATUS})
                </div>
              </div>
            </div>
            <img
              src={uploadIcon}
              alt="change session"
              style={{ height: "22px", width: "22px", opacity: 0.9 }}
            />
          </div>
        </div>

        {isOpenSessionDialog && (
          <MdlSelectSession
            action={HandleCloseSessionDialog}
            action2={HandleSelectedSession}
          />
        )}

        {/* Exam Selection */}
        <div
          style={{
            background: COLORS.white,
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: `1px solid ${COLORS.grey3}`,
          }}
        >
          <h6 style={{ 
            margin: "0 0 12px 0", 
            fontSize: "13px", 
            fontWeight: "700", 
            color: COLORS.primary_color_shade7,
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <i className="fa fa-file-text" style={{ fontSize: "15px", color: COLORS.primary_color_shade5 }} />
            Select Exam
          </h6>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {mExamList.map((item, index) => {
              const isSelected = EXAM_SELECTED_POSITION === index;
              return (
                <button
                  key={`exam-${item.exam_id}-${index}`}
                  onClick={() => SelectExam(item.exam_id, item.exam_name, index)}
                  style={{
                    padding: "10px 18px",
                    fontSize: "13px",
                    fontWeight: "600",
                    borderRadius: "8px",
                    border: `2px solid ${isSelected ? COLORS.primary_color_shade5 : COLORS.grey3}`,
                    background: isSelected
                      ? `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`
                      : `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey1} 100%)`,
                    color: isSelected ? COLORS.white : COLORS.primary_color_shade7,
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: isSelected
                      ? "0 4px 12px rgba(102, 126, 234, 0.35)"
                      : "0 2px 6px rgba(0, 0, 0, 0.1)",
                    transform: isSelected ? "translateY(-2px) scale(1.02)" : "translateY(0) scale(1)",
                    minWidth: "120px",
                    whiteSpace: "nowrap",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.25)";
                      e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
                      e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.borderColor = COLORS.grey3;
                    }
                  }}
                >
                  <i 
                    className="fa fa-check-circle" 
                    style={{ 
                      marginRight: "6px",
                      fontSize: "12px",
                      opacity: isSelected ? 1 : 0
                    }} 
                  />
                  {item.exam_name}
                </button>
              );
            })}
          </div>
        </div>

        {/* Sample Selection */}
        <div
          style={{
            background: COLORS.white,
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: `1px solid ${COLORS.grey3}`,
          }}
        >
          <h6
            style={{
              margin: "0 0 12px 0",
              fontSize: "13px",
              fontWeight: "700",
              color: COLORS.primary_color_shade7,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <i
              className="fa fa-clone"
              style={{ fontSize: "15px", color: COLORS.primary_color_shade5 }}
            />
            Sample List
          </h6>

          {(!mPrintableSamples || mPrintableSamples.length === 0) ? (
            <div
              style={{
                fontSize: "12px",
                color: COLORS.grey3,
                fontStyle: "italic",
              }}
            >
              No samples available for this document type.
            </div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {mPrintableSamples.map((item, index) => {
                const isSelected = SELECTED_SAMPLE_POSITION === index;
                const label = item.sample_name || item.sample_title || `Sample ${index + 1}`;
                return (
                  <button
                    key={`sample-${item.sample_id || index}`}
                    onClick={() => SelectSample(item, index)}
                    style={{
                      padding: "8px 14px",
                      fontSize: "12px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      border: `2px solid ${
                        isSelected ? COLORS.primary_color_shade5 : COLORS.grey3
                      }`,
                      background: isSelected
                        ? `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`
                        : `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey1} 100%)`,
                      color: isSelected ? COLORS.white : COLORS.primary_color_shade7,
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      boxShadow: isSelected
                        ? "0 4px 12px rgba(102, 126, 234, 0.35)"
                        : "0 2px 6px rgba(0, 0, 0, 0.1)",
                      transform: isSelected
                        ? "translateY(-2px) scale(1.02)"
                        : "translateY(0) scale(1)",
                      minWidth: "120px",
                      whiteSpace: "nowrap",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(102, 126, 234, 0.25)";
                        e.currentTarget.style.transform =
                          "translateY(-2px) scale(1.02)";
                        e.currentTarget.style.borderColor =
                          COLORS.primary_color_shade5;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.boxShadow =
                          "0 2px 6px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.borderColor = COLORS.grey3;
                      }
                    }}
                    title={label}
                  >
                    <i
                      className="fa fa-check-circle"
                      style={{
                        marginRight: "6px",
                        fontSize: "12px",
                        opacity: isSelected ? 1 : 0,
                      }}
                    />
                    {label}
                  </button>
                );
              })}
            </div>
          )}
        </div>


        {/* Preview Section */}
        <div
          style={{
            background: COLORS.white,
            borderRadius: "8px",
            padding: "14px",
            marginTop: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
            border: `1px solid ${COLORS.grey3}`,
          }}
        >
          <h6 style={{ 
            margin: "0 0 10px 0", 
            fontSize: "13px", 
            fontWeight: "700", 
            color: COLORS.primary_color_shade7,
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}>
            <i className="fa fa-eye" style={{ fontSize: "14px", color: COLORS.primary_color_shade5 }} />
            Preview
          </h6>
          <div
            style={{
              borderRadius: "6px",
              overflow: "hidden",
              border: `1px solid ${COLORS.grey3}`,
              minHeight: "500px",
              position: "relative",
            }}
          >
            {!FILE_URL ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "500px",
                background: COLORS.grey1,
                gap: "12px",
              }}>
                <i className="fa fa-file-text" style={{ fontSize: "32px", color: COLORS.grey3 }} />
                <div style={{
                  fontSize: "13px",
                  color: COLORS.grey3,
                  fontWeight: "500",
                }}>
                  Select an exam to preview
                </div>
              </div>
            ) : showPreview ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "500px",
                background: COLORS.grey1,
                gap: "12px",
              }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  border: `4px solid ${COLORS.grey3}`,
                  borderTop: `4px solid ${COLORS.primary_color_shade5}`,
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}></div>
                <div style={{
                  fontSize: "13px",
                  color: COLORS.primary_color_shade7,
                  fontWeight: "500",
                }}>
                  Loading preview...
                </div>
                <style>{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}</style>
              </div>
            ) : (
              <Iframe
                ref={iframeRef}
                key={FILE_URL}
                url={FILE_URL}
                width="100%"
                height={iFrameHeight}
                overflow="auto"
                id="iFrame1"
                display="initial"
                position="relative"
                scrolling="no"
                style={{
                  border: "none",
                  borderRadius: "6px",
                }}
                onLoad={handleIframeLoad}
                onError={handleIframeError}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamSchedule;
